import type { SVGProps } from 'react';

const SvgForwardingFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.58711 3.07929L21.0847 11.3282C21.4557 11.5137 21.606 11.9648 21.4205 12.3358C21.3479 12.4811 21.23 12.599 21.0847 12.6717L4.58711 20.9205C4.21612 21.106 3.76499 20.9557 3.57949 20.5847C3.48727 20.4002 3.47494 20.1859 3.54542 19.9921L5.7611 13.899C5.85073 13.6525 6.06244 13.4706 6.31962 13.4192L13.4158 11.9999L6.31962 10.5807C6.06244 10.5292 5.85073 10.3474 5.7611 10.1009L3.54542 4.0077C3.40367 3.61789 3.60477 3.18697 3.99458 3.04522C4.18839 2.97474 4.40265 2.98706 4.58711 3.07929Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgForwardingFilled;
